module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_percent_rank/1_31bcd8d6488bb258af28dd6ec0d327ff.png";